export default __webpack_public_path__ + "static/key-visual-3a3a189476aef01cbd5a4f2752ee127d.png";